<template>
  <v-card class="cardStyle mt-10">
    <v-col class="text-center" align-self="center">
      <v-card class="innerCardStyle pt-10 bestseller" elevation="0">
        <v-card-subtitle
            class="assistant text-center innerCardTitle headline white--text mb-8"
        >Edu Lab
        </v-card-subtitle>
        <div class="pt-6 pb-7"></div>
        <v-card-text class="mb-2">
					<span class="textColor">
            <v-col>
              <div>{{ $t('pages.price.educationalInstitution') }}</div>
              <div>{{ $t('pages.price.forMoreInformationContactUs') }}</div>
            </v-col>
					</span>
        </v-card-text>
        <v-btn class="pa-5" id="yellowBtn" @click="dialog = true">{{ $t("pages.price.contactUs") }}</v-btn>
      </v-card>
    </v-col>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">{{ $t('pages.price.contact.title') }}</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <smart-input v-model="form.name" :label="$t('pages.price.contact.name')" :required="true" outlined
                         rounded />
            <smart-input v-model="form.phone" :label="$t('pages.price.contact.phone')" outlined rounded />
            <smart-input v-model="form.email" :label="$t('pages.price.contact.email')" type="email" :required="true"
                         outlined rounded />
            <smart-input v-model="form.institution" :label="$t('pages.price.contact.institution')" :required="true"
                         outlined rounded />
            <smart-input v-model="form.message" :label="$t('pages.price.contact.message')" :required="true" outlined
                         textarea :rows="3"
                         rounded />

            <div class="mt-4">
              {{ $t('pages.price.contact.emailPrompt') }}
              <a :href="contactEmail" class="text-primary font-weight-medium">
                {{contactEmail}}
              </a>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions justify="center">
          <v-row justify="center" class="w-100" no-gutters>
            <v-btn color="main_pink" :disabled="loading" rounded @click="submit" class="font-weight-medium white--text">
              <span v-if="!loading">{{ $t('pages.price.contact.submit') }}</span>
              <span v-else>{{ $t('pages.price.contact.sending') }}</span>
            </v-btn>
            <v-btn text @click="dialog = false">{{ $t('generics.close') }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { publicApi } from "src/packages/MyAxios";

export default {
  name: "ContactPlanCard",
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      form: {
        name: '',
        phone: '',
        email: '',
        institution: '',
        message: '',
      }
    }
  },
  methods: {
    async submit() {
      debugger
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await publicApi.post('/contact', this.form);
          this.dialog = false;
          this.resetForm();
          this.$store.commit("SHOW_SNACKBAR", { message: this.$t('pages.price.contact.submission_success'), color: 'success' });
        } catch (error) {
          this.$store.commit("SHOW_SNACKBAR", { message: this.$t('pages.price.contact.submission_error'), color: 'error' });
          console.error(error);
        } finally {
          this.loading = false;
          this.resetForm()
        }
        this.dialog = false

      }
    },
    resetForm() {
      this.form = {
        name: '',
        phone: '',
        email: '',
        institution: '',
        message: '',
      };
    },
  },
  computed: {
    isValid() {
      return this.form.name && this.form.email && this.form.institution && this.form.message;
    },
    contactEmail() {
      return this.$store.state.env.CONTACT_EMAIL;
    }
  }
}
</script>

<style scoped>

</style>
